import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

type Props = { artistId: string; groupId: number };

export const deleteUnsubscribeGroup = async ({ artistId, groupId }: Props) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!groupId) throw Error('Group ID is required');

  const url = `/web/studio/artists/${artistId}/unsubscribe-groups/${groupId}`;

  const response = await api.executeDeleteRequest<ObjectResponse<unknown>>(url);

  return response.data;
};
